import { Component, OnInit } from '@angular/core';
import { Auth, ViewState} from 'src/common'
@Component({
  selector: 'app-internaluser-details',
  templateUrl: './internaluser-details.component.html'

})
export class InternalUserDetailsComponent  implements OnInit{

  viewState = ViewState;
  
  constructor() { }

  ngOnInit (): void {
    //Auth.checkAuthorization('');
    
    
  }


}